
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-integrations/odoo",
      function () {
        return require("private-next-pages/whatsapp-integrations/odoo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-integrations/odoo"])
      });
    }
  